import { AccountType } from '../../types';
export var list = [
    AccountType.RTO,
    AccountType.CONSEIL,
    AccountType.GESTION,
];
